export const storeEN = {
	backofficeStore: {
		createTransfer: "Transfer performed successfully",
		editTransfer: "Transfer edited successfully",
		deleteTransfer: "Transfer deleted successfully",
		editBill: "Account successfully edited",
		deleteBill: "Account deleted",
		importBackofficeBills: "Imported accounts",
		createBillTypes: "Account type created successfully",
		createCostCenters: "Created cost center",
		deleteCostCenter: "Deleted Cost Center",
		editCostCenter: "Edited Cost Center",
		deleteAccount: "Customer account deleted",
		editAccount: "Edited customer account",
		editBillTypes: "Edited Account Type",
		deleteBillTypes: "Account type deleted",
		createCategorie: "Category created",
		editCategorie: "Edited Category",
		deleteCategorie: "Category deleted",
		addStorage: "Inventory created successfully",
		updateStorage: "Successfully modified stock",
		updateBar: "Bar edited successfully",
		deleteBar: "The bar was deleted",
		addBar: "Bar added",
		createNewSupplier: "New supplier added successfully",
		inputBackofficeProductsV2_zero: "Products added to stock",
		inputBackofficeProductsV2_other: "One or more products were not added",
		zeroBackofficeAllProductsAtStorage: "All products zeroed",
		editSupplier: "Supplier edited successfully",
		saveBackofficeProductsQuantityV2: "Updated Product",
		deleteBackofficeProduct: "Product deleted from stock",
		deleteBackofficeProducts: "All products have been deleted from stock",
		deleteSupplier: "Supplier deleted successfully",
		transferBackofficeProduct: "Transferred Product",
		createAccount: "Account launched successfully",
		deleteInvoices: "Invoices deleted successfully",
	},
	barStore: {
		deleteBar: "Bar removed.",
		editBar: "Bar updated.",
		addTableBarRange: "Added table printing configuration.",
		editTableBarRange: "Updated table printing configuration.",
		deleteRange: "Tablet printing configuration removed.",
	},
	cmvStore: {
		error: {
			getCategories: "Error fetching category",
		},
		updatedProductsWithoutCostOnSells: "Cost updated successfully",
	},
	cashierStore: {
		bleedCashier_zero: "Successful Exchange Fund",
		bleedCashier_other: "Bleeding was successful.",
		addCashierClosingObs: "Added note.",
		createCashierChangeLEGACY: "Added Change Fund",
		createMultipleChangesLEGACY: "All funds have been registered",
		createMultipleChangesLEGACYError:
			"{{errors}} from {{cashiersId}} gave error: {{jsonErrors}}",
		createBleedLEGACY: "Bleed added",
		updateCashierClosingLEGACY: "Cashier closed successfully",
	},
	clientStore: {
		getClientByCPFOrPhone: "Customer added",
		editClientDetails: "Updated client details.",
		editClientDetailsPlace: "Updated client details.",
		editUserDetails: "Updated customer details.",
		payBillAtPlace: "Account successfully paid",
		payAllBillsAtPlace: "Bills successfully paid",
		clientAlreadyAdded: "This client has already been added",
		payBillsSuccess: "Accounts paid successfully",
		payBillsWarning:
			"{{success}} bills successfully paid, and {{errors}} errors paying bills.",
		payBillsLoading: "Marking as paid",
		createPixCharge: "PIX created successfully",
		updatedProductsWithoutCostOnSells: "Cost updated successfully",
		refundAppSell:
			"Transaction reversed successfully! Refresh the page to view the information correctly.",
		cancelAppSell:
			"Transaction canceled successfully! Refresh the page to view the information correctly.",
	},
	comboStore: {
		createCombo: "Combo created.",
		deleteCombo: "Combo removed.",
		editCombo: "Updated combo.",
	},
	deliveryStore: {
		deleteMenu: "Menu deleted successfully!",
		addProduct: "Successfully added product!",
		addProductV2: "Successfully added product!",
		activateManyProductsLoading: "Activating products",
		activateManyProductsWarning: "{{countFailures}} product(s) could not be updated.",
		deactivateManyProductsLoading: "Disabling products",
		deactivateManyProductsWarning: "{{countFailures}} product(s) could not be updated.",
	},
	deviceStore: {
		removeDeviceFromEvent: "Device removed from event.",
		updateEmployeeDeviceConfigs: "POS configured successfully",
		addDevice: "Device added to Location successfully",
	},
	employeeStore: {
		addEmployee: "Employee added.",
		editEmployee: "Employee updated.",
		removeEmployee: "Employee removed.",
		addMultipleEmployees: {
			error: "Error adding employees:",
			success: "Employees added successfully:",
		},
		removeMultipleEmployees: "{{successCount}} employees successfully removed",
		removeMultipleEmployeesError: "{{errorCount}} employees could not be removed",
		createRole: "Role created successfully",
		deleteRole: "Role successfully removed",
		updateRole: "Role edited successfully",
	},
	eventStore: {
		createEvent: "Created event.",
		openEvent: "Open event.",
		payBillAtEventWithMultiplePayments: "Bill paid successfully",
		payAllBillsAtEvent: "Bills successfully paid",
		closeEvent: "Closed event.",
		eventEditedSuccessfully: "Event edited successfully",
		closeEventLoading: "Closing event",
		deleteEvent: "Event removed.",
		emitInnovaroGeneralInvoices: "Notes issued successfully",
		refundFichaSell: "Token successfully reversed",
		giveRechargeToUser: "Recharge created successfully",
	},
	extractStore: {
		createBankAccount: "Bank account created successfully.",
		deleteBankAccount: "Bank account successfully removed!",
		updateBankAccount: "Bank account updated successfully!",
		createAdjustmentInVendorExtract: "Adjustment added successfully",
		payVendorWithdrawRequests: "Approvals sent successfully!",
		revertManyVendorsWithDrawRequests: "Reject request sent successfully!",
		orderWithdrawCancellation: "Cancellation request sent successfully.",
	},
	fiscalStore: {
		createFiscalProfile: "Successful creating tax profile.",
		editFiscalProfile: "Success while updating fiscal profile.",
		createFiscalProductGroup: "Successful creating tax group.",
		editFiscalProductGroup: "Success while updating tax group.",
		deleteFiscalProductGroup: "Success while updating tax group.",
		issueManualInvoiceForReserveError_zero:
			"Error generating {{failedInvoiceCount}} invoices",
		issueManualInvoiceForReserveError: "Error n°{{number}}: {{error}}",
		issueManualInvoiceForReserve_zero: "All invoices generated successfully",
		issueManualInvoiceForReserve_other:
			"{{issuedInvoices}} Invoices generated successfully",
		minimumConsumptionFiscalSuccess: "Minimum consumption configured successfully",
		rechargeFiscalSuccess: "Recharge configured successfully",
	},
	invoiceStore: {
		notifyOfIssuing_zero: "There were no notes to issue",
		notifyOfIssuing_other: "{{invoiceCount}} invoices issued",
		notifyOfIssuingWarning_other:
			"{{issuedInvoices}} invoices issued, but the following errors were found: {{errors}}",
		notifyOfIssuingWarning_zero:
			"No invoice issued, the following errors were found: {{errors}}",
		issueAllEventInvoices: "Event invoices issued.",
		sendInvoicesByEmail: "Notes sent by email.",
		cancelInvoice: "Invoice canceled successfully!",
		cancelInvoiceNC:
			"Credit note generated successfully! Your credit note will be available shortly",
		issueInvoicesOfTransactions: "Invoices issued",
	},
	itemStore: {
		activateProductsInPlaceLoading: "Activating products",
		activateProductsInPlace: "Activated Products",
		activateSingleProductInPlace: "Activated Product",
		deactivateProductsInPlaceLoading: "Deactivating products",
		deactivateProductsInPlace: "Deactivated Products",
		deactivateSingleProductInPlace: "Deactivated Product",
		createCategory: "Category created successfully",
		editCategory: "Updated Category",
		deleteCategory: "Category deleted",
		addProduct: "Added Product",
		importProductsError: "Error editing product {{name}}: {{message}}",
		importProducts: "{{products}} Imported products",
		importProductsWarning:
			"{{products}} Imported products and {{errorCounter}} products had problems importing",
		editProduct: "Updated Product",
		importProductsToEditError: "Error editing product {{name}}: {{message}}",
		importProductsToEdit: "{{products}} Edited products",
		importProductsToEditWarning:
			"{{products}} Edited products and {{errorCounter}} products had editing problems",
		deleteProduct: "Product removed",
		deleteProductError: "Error removing product",
		deleteProductFromPlace: "Product removed",
		activateMountableSectionItem_all: "Successfully activated items",
		activateMountableSectionItem_one: "Item activated successfully",
		deactivateMountableSectionItem_all: "Successfully deactivated items",
		deactivateMountableSectionItem_one: "Item deactivated successfully",
		addSupply: "Input added",
		editSupply: "Input changed",
		createEntrance: "Added Entry",
		deleteEntrance: "Entry removed",
		editEntrance: "Updated entry",
		editEntranceImage: "Updated entry",
		attachProductionRule: "Data sheet created successfully",
		removeProductionRule: "Data sheet removed successfully",
		editProductionRule: "Updated Production Rule",
		removedProductionRuleInput: "Input removed successfully",
		editMultipleProducts: "{{name}} successfully modified!",
		editMultipleProductsError: "{{name}} could not be changed: {{reason}}",
		deleteMultipleProducts: "Successfully removed",
		createBeerTap: "Shop created successfully!",
		editBeerTap: "Chopeira edits successfully!",
		removeBeerTap: "Successfully deleted brewery!",
		activatingProduct: "Activating product",
		deactivatingProduct: "Deactivating product",
		activatedProduct: "Activated product",
		deactivatedProduct: "Deactivated product",
		activatingEntrance: "Activating entrance",
		deactivatingEntrance: "Deactivating entrance",
		activatedEntrance: "Activated entrance",
		deactivatedEntrance: "Deactivated entrance",
		errorToAdd: "Error adding {{name}}",
	},
	organizationStore: {
		addGiftback: "Giftback created successfully",
		addProductToOrg: "Added Product",
		addMultipleOrgProducts: "Added Products",
		editGiftback: "Giftback edited successfully",
		editOrgProduct: "Edited Product",
		editMultipleOrgProducts: "Edited Products",
		deleteMultipleOrgProducts:
			"({{products}}) products have been removed from inventory at all locations.",
		deleteGiftback: "Giftback deleted successfully",
		deleteProduct: "Product removed",
		deleteProductError: "Error removing product",
		tooglePlaces: "Locations changed",
		addMultipleProductsInPlace: "Locations changed",
		activateGiftback: "Giftback activated successfully",
		deactivateGiftback: "Giftback deactivated successfully",
	},
	placeStore: {
		editEverestConfigWarning: "Validating data with everest",
		editEverestConfig: "Updated everest data.",
		editPlace: "Updated location.",
		confirmSignPlaceContracts: "Signature completed successfully.",
		createStorageAlerts: "Alert created successfully",
		editStorageAlerts: "Successfully edited alert",
		deleteStorageAlerts: "Alert deleted successfully",
		addEmailToMinimumStorageAlert: "Emails successfully registered",
		removeEmailToMinimumStorageAlert: "Email successfully removed",
		deleteDiscountCategory: "Discount successfully removed!",
		activateDiscountCategory: "Discount activated successfully!",
		disableDiscountCategory: "Discount successfully disabled!",
		createManualLostReport: "Manual loss created successfully.",
		updatePlaceSettingsGeneralSection: "Updated general settings.",
		updatePlaceSettingsFichaSection: "Updated token settings.",
		updatePlaceSettingsCouvertSection: "Updated Couvert settings.",
		updatePlaceSettingsPlaceFeatureSection: "Update Feature settings.",
		updatePlaceSettingsPDVSection: "Update PDV settings.",
		updatePlaceSettingsTotemSection: "Totem settings updated.",
		createPixCharge: "PIX created successfully",
	},
	productFeatureStore: {
		org: "ORG",
		zig: "ZIG",
		createProductFeatureTemplate: "Product functionality model created successfully!",
		editProductFeatureTemplate: "Product functionality template edited successfully!",
		removeProductFeatureTemplate: "Product functionality template removed successfully!",
		createProductFeature: "Product feature created successfully!",
		editProductFeature: "Successfully edited product feature!",
		removeProductFeature: "Product functionality removed successfully!",
		removeProductFeaturesByTemplateId:
			"Product features linked to the template were successfully removed!",
	},
	promotionStore: {
		createPromotion: "Promotion created successfully",
		editPromotion: "Successfully edited promotion",
		updatePromotionPeople: "Customers successfully updated",
		usersInfoRewriteLoading: "Fetching customer data, this can take a long time",
		deletePromotion: "Promotion deleted successfully",
	},
	relationStore: {
		editRelation: "Successfully edited list information!",
		deleteRelation: "Successfully deleted list",
		deleteMultipleRelation_one: "Successfully deleted list",
		deleteMultipleRelation_other: "Successfully deleted lists",
		addRelationUser: "Guest added successfully!",
		editRelationUser: "Guest edited successfully!",
		deleteRelationUser: "User deleted from list successfully",
		activateOrDeactivateRelation_active: "Lists activated successfully",
		activateOrDeactivateRelation_deactive: "Successfully deactivated list",
	},
	reserveStore: {
		addReserve: "Package created successfully",
		editReserve: "Package modified successfully",
		deleteReserve: "Package deleted successfully",
		createReserveTemplate: "Package template created successfully!",
	},
	smsStore: {
		cancelSmsCampaign: "Schedule canceled.",
		editSmsCampaignClients: "Recipient group changed.",
	},
	vendorStore: {
		createVendor: "Vendor created successfully",
		editVendor: "Successfully edited vendor",
	},
	whatsUpStore: {
		setPlaceDetailStatus_active: "Active location in Zig App",
		setPlaceDetailStatus_inactive: "Place inactive in Zig App",
	},
};
